import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M11 16.17L7.41 12.59L6 14L12 20L18 14L16.59 12.59L13 16.17V4H11V16.17Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "ShortDown"
);
